export default {
    // Header
    brand: 'PlayCatGames',
    nav: {
        home: 'Inicio',
        games: 'Juegos',
        categories: 'Categorías',
        about: 'Acerca de'
    },
    search: {
        placeholder: 'Buscar juegos de gatos...'
    },

    // Hero Section
    hero: {
        title: 'Juegos de Gatos',
        description: 'Los juegos de gatos en PlayCatGames te permiten jugar, cuidar e interactuar con gatos virtuales de formas divertidas e ingeniosas. Puedes hacer clic o tocar para lanzar juguetes por la pantalla, arrastrar y soltar atuendos en un personaje, o usar reflejos rápidos para atrapar peces y perseguir recompensas.',
        subtitle: 'Algunos juegos de gatos prueban el tiempo mientras saltas, corres o escalas, mientras que otros se enfocan en acciones simples como alimentar, acicalar o tocar para ganar puntos. Cada título está diseñado para diversión instantánea en tu navegador. Sin instalaciones. Sin descargas. ¡Solo miau!',
        buttons: {
            start: 'Empezar a Jugar',
            browse: 'Explorar Categorías'
        },
        stats: {
            games: 'Juegos Gratis',
            categories: 'Categorías de Juegos',
            free: 'Experiencia Gratuita',
            available: 'Siempre Disponible'
        }
    },

    // Games Section
    games: {
        title: 'Juegos de Gatos Populares',
        subtitle: 'Descubre los juegos de gatos en línea gratuitos más populares para jugadores de todas las edades',
        filters: {
            all: 'Todos',
            dressUp: 'Vestir',
            care: 'Cuidado',
            puzzle: 'Rompecabezas',
            arcade: 'Arcade',
            simulation: 'Simulación'
        },
        loadMore: 'Cargar Más Juegos',
        gameCategories: {
            arcade: 'Arcade',
            simulation: 'Simulación',
            care: 'Cuidado',
            puzzle: 'Rompecabezas',
            dressUp: 'Vestir'
        }
    },

    // Categories Section
    categories: {
        title: 'Categorías de Juegos',
        subtitle: 'Cada juego de gatos está construido alrededor de actividades que los jugadores más disfrutan: estilismo, cuidado de mascotas, o corriendo por cursos divertidos',
        browse: 'Explorar Categoría',
        featuredGames: 'Juegos Destacados',
        gameCount: 'Juegos',
        types: {
            dressUp: {
                name: 'Juegos de Vestir Gatos',
                description: 'Los juegos de vestir gatos dejan volar tu creatividad. Mezcla atuendos, añade accesorios y desbloquea looks temáticos desde sets de fantasía hasta equipos estacionales.'
            },
            simulation: {
                name: 'Simulación y Juego de Roles de Gatos',
                description: 'En los juegos de simulador, te pones en las patas de un gato. Deambula, explora y vive la vida curiosa de un gatito.'
            },
            puzzle: {
                name: 'Gestión de Gatos y Juegos de Rompecabezas',
                description: 'Para los fanáticos de la estrategia, los juegos de rompecabezas y gestión de gatos ofrecen giros inteligentes. Equilibra múltiples gatos, resuelve desafíos de apilamiento complicados.'
            },
            arcade: {
                name: 'Juegos de Arcade y Acción de Gatos',
                description: 'Juegos de arcade de gatos de ritmo rápido que prueban tus reflejos y agilidad. Salta, corre, atrapa y disfruta de experiencias de juego emocionantes.'
            }
        },
        additional: {
            title: 'Explora Más Tipos de Juegos de Gatos',
            description: 'Nuestra colección de juegos de gatos cubre cada estado de ánimo y preferencia: juego de moda, cuidado de mascotas, rompecabezas complicados o carreras de arcade divertidas. Nuestros juegos de gatos basados en navegador son gratuitos, seguros y listos para jugar en segundos.',
            motto: '¡Solo elige un juego, toca inicio y deja que la diversión cobre vida!'
        }
    },

    // About Section
    about: {
        title: 'Acerca de PlayCatGames',
        description: [
            'PlayCatGames es tu destino definitivo para explorar el maravilloso mundo de los juegos de gatos. Hemos seleccionado cuidadosamente una colección de juegos temáticos de gatos en línea gratuitos adecuados para jugadores de todas las edades.',
            'Desde juegos de vestir adorables hasta aventuras de arcade emocionantes, desde simulaciones de cuidado cálidas hasta desafíos de rompecabezas inteligentes, nuestra colección de juegos cubre todo lo que los amantes de los gatos podrían desear. Todos los juegos son cuidadosamente seleccionados para garantizar la mejor experiencia de juego.',
            'Creemos que los juegos deben ser instantáneos, divertidos y fácilmente accesibles. Por eso todos nuestros juegos pueden ejecutarse directamente en tu navegador sin descargar o instalar ningún software. ¡Solo haz clic y comienza a jugar!'
        ],
        features: {
            free: '100% Juegos Gratis',
            mobile: 'Amigable para Móviles',
            instant: 'Juego Instantáneo',
            safe: 'Seguro y Protegido'
        },
        faq: {
            title: 'Preguntas Frecuentes',
            questions: {
                free: {
                    q: '¿Estos juegos son realmente gratis?',
                    a: '¡Sí! Todos nuestros juegos de gatos son completamente gratuitos. No necesitas pagar nada para disfrutar de todo el contenido del juego.'
                },
                download: {
                    q: '¿Necesito descargar algún software?',
                    a: '¡No! Todos los juegos pueden ejecutarse directamente en tu navegador. Solo haz clic en un juego para comenzar a jugar, no se requieren descargas o instalaciones.'
                },
                age: {
                    q: '¿Para qué grupo de edad son adecuados estos juegos?',
                    a: 'Nuestros juegos de gatos son adecuados para jugadores de todas las edades. Desde juegos de vestir simples hasta juegos de rompecabezas desafiantes, todos pueden encontrar juegos que les convengan.'
                },
                mobile: {
                    q: '¿Los juegos soportan dispositivos móviles?',
                    a: '¡Sí! Todos nuestros juegos están optimizados para funcionar perfectamente en PC, tabletas y teléfonos. Puedes disfrutar de la diversión del juego en cualquier momento y lugar.'
                },
                updates: {
                    q: '¿Añadirán nuevos juegos?',
                    a: '¡Absolutamente! Actualizamos regularmente nuestra biblioteca de juegos y añadimos nuevos juegos de gatos interesantes. Por favor vuelve frecuentemente para revisar el contenido de juegos más reciente.'
                }
            }
        }
    },

    // Footer
    footer: {
        description: 'Tu destino de colección de juegos de gatos en línea gratuitos. Descubre, juega y disfruta docenas de emocionantes juegos temáticos de gatos.',
        quickLinks: 'Enlaces Rápidos',
        gameCategories: 'Categorías de Juegos',
        support: 'Soporte',
        links: {
            popularGames: 'Juegos Populares',
            latestGames: 'Últimos Juegos',
            recommendedGames: 'Juegos Recomendados',
            faq: 'Preguntas Frecuentes',
            contact: 'Contáctanos',
            feedback: 'Comentarios',
            privacy: 'Política de Privacidad',
            terms: 'Términos de Servicio',
            cookies: 'Política de Cookies',
            sitemap: 'Mapa del Sitio'
        },
        copyright: 'Todos los derechos reservados.',
        disclaimer: 'Todo el contenido del juego se obtiene de internet solo para fines de entretenimiento y educación. Por favor contáctanos si hay algún problema de derechos de autor.',
        backToTop: 'Volver Arriba',
        friendlyLinks: 'Enlaces Amigos'
    },

    // Game Data
    gameData: {
        descriptions: {
            kittyLovesBirds: 'Ayuda al gatito a atrapar pájaros voladores y muestra tu velocidad de reacción',
            catPizza: 'Dirige una pizzería de gatos y haz deliciosas pizzas para los clientes',
            funnyKittyCare: 'Cuida gatitos adorables, aliméntalos, báñalos y juega',
            catsDrop: 'Juego de apilamiento de gatos que prueba tus habilidades de equilibrio y estrategia',
            catpad: 'Adorable juego de plataforma de salto de gatos',
            funnyKittyDressup: 'Viste gatitos adorables con varias ropas y accesorios',
            kittyCats: 'Juego casual para interactuar con múltiples gatos adorables',
            dualCat: 'Juego de desafío controlando dos gatos simultáneamente',
            funnyKittyHaircut: 'Juego de belleza diseñando peinados de moda para gatitos',
            catCoffeeShop: 'Dirige una cafetería de gatos y haz bebidas deliciosas'
        },
        categories: {
            puzzle: 'Rompecabezas',
            simulation: 'Simulación',
            casual: 'Casual',
            action: 'Acción',
            adventure: 'Aventura',
            strategy: 'Estrategia',
            sports: 'Deportes',
            racing: 'Carreras',
            dressup: 'Vestir',
            care: 'Cuidado'
        },
        tags: {
            cute: 'Lindo',
            anime: 'Anime',
            dark: 'Oscuro',
            funny: 'Divertido',
            educational: 'Educativo',
            multiplayer: 'Multijugador',
            relaxing: 'Relajante',
            challenging: 'Desafiante',
            colorful: 'Colorido',
            simple: 'Simple',
            complex: 'Complejo',
            family: 'Familiar',
            kids: 'Niños',
            adult: 'Adulto'
        }
    },

    // Common
    common: {
        loading: 'Cargando...',
        error: 'Algo salió mal',
        retry: 'Reintentar',
        play: 'Jugar',
        language: 'Idioma',
        backToHome: 'Volver al Inicio'
    },

    // Legal Pages (simplified)
    legal: {
        privacy: { title: 'Política de Privacidad', lastUpdated: 'Última Actualización' },
        terms: { title: 'Términos de Servicio', lastUpdated: 'Última Actualización' },
        cookies: { title: 'Política de Cookies', lastUpdated: 'Última Actualización' }
    },

    // Sitemap
    sitemap: {
        title: 'Mapa del Sitio',
        description: 'Encuentra todas las páginas y contenido en el sitio web de PlayCatGames'
    }
}